import React from "react";
import AuthService from "../services/authentication";
import Logo from "images/pop-logo.svg";
import { Link, useLocation } from "react-router-dom";
import { useOrder } from "../data/order";
import Notification from "../components/notification";
import { cn } from "../ui";

const navLinkClass = (active) =>
  cn("px-4 py-1 font-medium text-integria-green", active && "underline font-bold");

function Header(props) {
  let auth = AuthService.useAuth();
  const location = useLocation();

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/transaction/") ||
    location.pathname.includes("/faq")
  )
    return <></>;
  const isPatientPage =
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payment-success") ||
    location.pathname.includes("/login");

  let { order } = useOrder(auth.authHeader());

  return (
    <>
      <nav className="flex items-center gap-2 mb-2 w-full px-4 py-2 bg-white">
        <img
          width="210"
          height="52"
          src={Logo}
          style={{ objectFit: "contain" }}
          className="inline-block align-top"
          alt="Integria Logo"
        />
        {auth.user && !location.pathname.includes("/patient/order") && (
          <div className="flex items-center justify-start">
            <Link to="/" className={navLinkClass(location.pathname == "/")}>
              Home
            </Link>
            <Link
              to="/prescriptions"
              className={navLinkClass(location.pathname == "/prescriptions")}
            >
              Prescriptions
            </Link>
            <Link
              to="/patients"
              className={navLinkClass(location.pathname == "/patients")}
            >
              Patients
            </Link>
            <Link
              to="/transactions"
              className={navLinkClass(location.pathname == "/transactions")}
            >
              Transactions
            </Link>
            {order && (
              <Link
                to="/order"
                className={navLinkClass(
                  location.pathname == "/order" ||
                    location.pathname == "/order/edit"
                )}
              >
                Current Order
              </Link>
            )}
          </div>
        )}
      </nav>
      {!isPatientPage && (
        <Notification
          cookieName="PracWebsiteUpdateNotification052025"
          title="Website Update!"
          content={"Moved from nz.patient.integria.com to patient.integria.com"}
        />
      )}
    </>
  );
}

export default Header;
